import { render, staticRenderFns } from "./distributorRelItems.vue?vue&type=template&id=9bd0af98&scoped=true"
import script from "./distributorRelItems.vue?vue&type=script&lang=js"
export * from "./distributorRelItems.vue?vue&type=script&lang=js"
import style0 from "./distributorRelItems.vue?vue&type=style&index=0&id=9bd0af98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd0af98",
  null
  
)

export default component.exports